export enum ChemotherapyArticleTypes {
    ORAL = 'oral',
    DOCTOR = 'doctor'
}
